import React, { useState } from "react";
import { Grid } from '@material-ui/core'
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import { IconDeleteBlue, IconEdit } from "icons";
import { PCOInvoiceDetailsStyle } from "./PCOInvoiceDetailsStyle";
import { IconButton } from "@mui/material";

export const EditWrapper = ({
    readonlyComponent,
    editComponent,
    onSave,
    onCancel,
    onDelete,
    editMode = false,
    loading,
    editable = false
}) => {

    const classes = PCOInvoiceDetailsStyle();
    const [edit, setEdit] = useState(editMode);

    return (
        <Grid container className={classes.fieldWrapper} alignItems="center">
            <Grid item xs={11} className={classes.field} >
                {edit ? editComponent : readonlyComponent}
                <div className={classes.icons} >
                    {!edit && editable &&
                        <IconButton onClick={() => setEdit(true)} >
                            <IconEdit />
                        </IconButton>
                    }
                    {!edit && onDelete && <IconButton disabled={loading}  onClick={async () => {
                        onDelete && onDelete();
                    }} ><IconDeleteBlue /></IconButton>}
                </div>
            </Grid>
            {edit &&
                <Grid item xs={1} >
                    <IconButton disabled={loading} size='small' onClick={async () => {
                        await onSave();
                        setEdit(false);
                    }} ><CheckIcon /></IconButton>
                    <IconButton disabled={loading} size='small' onClick={async () => {
                        onCancel && onCancel();
                        setEdit(false);
                    }} ><CloseIcon /></IconButton>

                </Grid>
            }
        </Grid>
    )
}